import { stickify } from '../modules/sticky-sidebar.js'
const isFixed = 'is-fixed'

/**
 * [stickToBottom description]
 * @param  {object} stickyEl     [Element which will be sticky]
 * @param  {string} className    [Class added on element while sticky]
 * @param  {object} threshholdEl [Element at which the sticky st]
 */
function stickToBottom(stickyEl, className, threshholdEl) {
  if (document.scrollingElement.scrollTop + window.innerHeight > threshholdEl.offsetTop) {
    stickyEl.classList.remove(isFixed)
  } else {
    stickyEl.classList.add(isFixed)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.js-fixed-filter-button')) {
    const fixedFilterBtn = document.querySelector('.js-fixed-filter-button')
    const footer = document.querySelector('.footer')

    window.addEventListener('load', function () {
      if (window.innerWidth < 960) {
        stickToBottom(fixedFilterBtn, isFixed, footer)
      }
    })

    window.addEventListener('resize', function () {
      if (window.innerWidth > 959) {
        fixedFilterBtn.classList.remove(isFixed)
      }
    })

    window.addEventListener('scroll', function () {
      if (window.innerWidth < 960) {
        stickToBottom(fixedFilterBtn, isFixed, footer)
      }
    })
  }
})
